import React from 'react'
// @ts-ignore
//import { Stocks } from 'stocks.js'
import { useEffect } from 'react'

function InvestPage() {
  return (
    <button></button>
  )
}

export default InvestPage